import styled from 'styled-components';

export const StyledPageTitle = styled.div<{ lineLength?: number }>`
    max-width: ${({ lineLength }) => `${lineLength || 100}ch`};
`;
